import getFaceRecognitionToken from './getFaceRecognitionToken';
import getUrl from './getUrl';
import getUserToken from './getUserToken';

export default {
  getFaceRecognitionToken,
  getUrl,
  getUserToken,
}
